/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WorkflowProcessEntity,
} from '../models/index';
import {
    WorkflowProcessEntityFromJSON,
    WorkflowProcessEntityToJSON,
} from '../models/index';

export interface ApproveWorkflowProcessRequest {
    processId: string;
    body: object;
}

export interface ApproveWorkflowProcessWithNodeIdRequest {
    processId: string;
    nodeId: string;
    body: object;
}

export interface RejectWorkflowProcessRequest {
    processId: string;
    body: object;
}

export interface RejectWorkflowProcessWithNodeIdRequest {
    processId: string;
    nodeId: string;
    body: object;
}

export interface RevertWorkflowProcessRequest {
    processId: string;
    nodeId: string;
}

export interface SaveWorkflowProcessRequest {
    processId: string;
}

export interface SaveWorkflowProcessWithNodeIdRequest {
    processId: string;
    nodeId: string;
}

export interface StartWorkflowProcessRequest {
    modelId: string;
}

export interface SubmitWorkflowProcessRequest {
    processId: string;
    body: object;
}

export interface SubmitWorkflowProcessWithNodeIdRequest {
    processId: string;
    nodeId: string;
    body: object;
}

/**
 * 
 */
export class EngineApi extends runtime.BaseAPI {

    /**
     * 指定したワークフロープロセスに対し、承認のアクションを実行する。
     */
    async approveWorkflowProcessRaw(requestParameters: ApproveWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling approveWorkflowProcess().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling approveWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/approve/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、承認のアクションを実行する。
     */
    async approveWorkflowProcess(requestParameters: ApproveWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.approveWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスに対し、承認のアクションを実行する。
     */
    async approveWorkflowProcessWithNodeIdRaw(requestParameters: ApproveWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling approveWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling approveWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling approveWorkflowProcessWithNodeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/approve/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、承認のアクションを実行する。
     */
    async approveWorkflowProcessWithNodeId(requestParameters: ApproveWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.approveWorkflowProcessWithNodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスに対し、却下のアクションを実行する。
     */
    async rejectWorkflowProcessRaw(requestParameters: RejectWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling rejectWorkflowProcess().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling rejectWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/reject/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、却下のアクションを実行する。
     */
    async rejectWorkflowProcess(requestParameters: RejectWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.rejectWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスに対し、却下のアクションを実行する。
     */
    async rejectWorkflowProcessWithNodeIdRaw(requestParameters: RejectWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling rejectWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling rejectWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling rejectWorkflowProcessWithNodeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/reject/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、却下のアクションを実行する。
     */
    async rejectWorkflowProcessWithNodeId(requestParameters: RejectWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.rejectWorkflowProcessWithNodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスに対し、取り戻しのアクションを実行する
     */
    async revertWorkflowProcessRaw(requestParameters: RevertWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling revertWorkflowProcess().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling revertWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/revert/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、取り戻しのアクションを実行する
     */
    async revertWorkflowProcess(requestParameters: RevertWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.revertWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスのプロセスデータを保存する。
     */
    async saveWorkflowProcessRaw(requestParameters: SaveWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling saveWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/save/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスのプロセスデータを保存する。
     */
    async saveWorkflowProcess(requestParameters: SaveWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.saveWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスのプロセスデータを保存する。
     */
    async saveWorkflowProcessWithNodeIdRaw(requestParameters: SaveWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling saveWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling saveWorkflowProcessWithNodeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/save/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスのプロセスデータを保存する。
     */
    async saveWorkflowProcessWithNodeId(requestParameters: SaveWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.saveWorkflowProcessWithNodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフローモデルのプロセスを新規に開始する。
     */
    async startWorkflowProcessRaw(requestParameters: StartWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling startWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/start/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフローモデルのプロセスを新規に開始する。
     */
    async startWorkflowProcess(requestParameters: StartWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.startWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスに対し、提出のアクションを実行する。
     */
    async submitWorkflowProcessRaw(requestParameters: SubmitWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling submitWorkflowProcess().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling submitWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/submit/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、提出のアクションを実行する。
     */
    async submitWorkflowProcess(requestParameters: SubmitWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.submitWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したワークフロープロセスに対し、提出のアクションを実行する。
     */
    async submitWorkflowProcessWithNodeIdRaw(requestParameters: SubmitWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling submitWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling submitWorkflowProcessWithNodeId().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling submitWorkflowProcessWithNodeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/engine/submit/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 指定したワークフロープロセスに対し、提出のアクションを実行する。
     */
    async submitWorkflowProcessWithNodeId(requestParameters: SubmitWorkflowProcessWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.submitWorkflowProcessWithNodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
